import { Component, Input, ViewChild } from '@angular/core';
import { RecursoCampanhaFormComponent } from '../../../recursos/components/form';
import { CampanhaFilter } from '../../filter';
import { CampanhaPedidoViewComponent } from '../../pedidos/view';
import { CampanhaRecurso } from '../campanha-recurso';


@Component({
    selector: 'sgt-campanha-recurso-view',
    templateUrl: './campanha-recurso-view.component.html',
    styleUrls: ['./campanha-recurso-view.component.less']
})
export class CampanhaRecursoViewComponent {
    @Input() idCampanha: number;
    @Input() isStatusEmAnalise: boolean;
    @Input() idArea: number;
    @Input() filter: CampanhaFilter;

    @Input() recursos: CampanhaRecurso[];
    // Bonificações
    isFirstSearchBonificacoes = true;
    @Input() quantidadePedidosBonificacoes: number;
    @Input() quantidadePedidosBonificacoesNaoLiberados: number;
    @Input() quantidadeTotalPedidosBonificacoes: number;
    @Input() valorTotalPedidosBonificacoes: number;
    @Input() valorTotalDespesas: number;
    // Vendas
    @Input() quantidadePedidosVendasNaoLiberados: number;

    @ViewChild('recursoForm') recursoForm: RecursoCampanhaFormComponent;
    @ViewChild('resultadoBonificacoes', {static: true}) resultadoBonificacoes: CampanhaPedidoViewComponent;

    private resize() {
        jQuery(window).trigger('resize');
    }

    private searchBonificacoes() {
        this.resultadoBonificacoes?.search();
    }

    onTableResultadoBonificacoesClick() {
        setTimeout(() => {
            if (this.isFirstSearchBonificacoes) {
                this.searchBonificacoes();
                this.isFirstSearchBonificacoes = false;
            } else {
                this.resize();
            }
        }, 0);
    }
}
